var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
/* istanbul ignore next */
export const waitUntilDialogIsReady = (ms, command, callback, nb = 0) => __awaiter(void 0, void 0, void 0, function* () {
    nb++;
    if (yield askIfReady(ms, command)) {
        callback();
    }
    else {
        waitUntilDialogIsReady(ms, command, callback, nb);
    }
});
/* istanbul ignore next */
const askIfReady = (ms, command) => {
    return new Promise((resolve) => {
        setTimeout(() => {
            resolve(false);
        }, ms);
        chrome.runtime.sendMessage({
            command,
        }, (resp) => {
            if (resp)
                resolve(resp);
        });
    });
};
